import React from 'react'
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { useState } from 'react';
import { useEffect } from 'react';
import { useScope } from "../SelectProjectCompanyContainer"
import Send from '../../core/communication';
import { useParams } from 'react-router-dom';

const useReport = (groupId, reportId) => {
    const [accessToken, setAccessToken] = useState()
    const [embedUrl, setEmbedUrl] = useState()

    useEffect(() => {
        //busca o embedUrl
        if (groupId && reportId) {
            Send.post(`/azure/token`, {
                reportId, groupId
            }).then(({ embedUrl, accessToken }) => {
                setEmbedUrl(embedUrl)
                setAccessToken(accessToken)
            })
            .catch((e) => {
                console.log({ e })
                setEmbedUrl()
                setAccessToken()
            })
        }
    }, [groupId, reportId])

    return {
        accessToken, embedUrl
    }
}

const DashboardDetailsContainer = (props) => {
    const [data, setData] = useState();
    const { scope } = useScope()
    const { id } = useParams()

    useEffect(() => {
        Send.get(`/projects/${scope?.id}/dashboard/${id}`)
        .then(setData)
    }, [scope])

    const { accessToken, embedUrl } = useReport(data && data.group, data && data.report)

    if (!accessToken || !embedUrl || !data) {
        return <div />
    }

    return <PowerBIEmbed
        embedConfig={{
            type: 'report',   // Supported types: report, dashboard, tile, visual and qna
            id: data.report,
            embedUrl,
            accessToken,
            tokenType: models.TokenType.Embed,
            settings: {
                panes: {
                    filters: {
                        expanded: false,
                        visible: false
                    }
                },
                background: models.BackgroundType.Transparent,
            }
        }}

        eventHandlers={
            new Map([
                ['loaded', function () { console.log('Report loaded'); }],
                ['rendered', function () { console.log('Report rendered'); }],
                ['error', function (event) { console.log(event.detail); }]
            ])
        }
        cssClassName={"report-style-class"}
        getEmbeddedComponent={(embeddedReport) => {
            // this.report = embeddedReport;
            console.log({ embeddedReport })
        }}
    />
}

export default DashboardDetailsContainer;